<div class="container-mini py-5">
    <app-high-charts *ngIf="chartImporti" [options]="chartImporti" [height]="'280px'"></app-high-charts>
</div>
